<template>
  <div class="appraise-detail container">
    <div class="title">
      <el-button
        icon="el-icon-arrow-left"
        type="primary"
        class="back-btn"
        @click="$router.go(-1)"
        circle
      ></el-button>
      <b>学生素养</b>
      <el-button type="primary" class="submit-btn" @click="handleSubmit"
        >确定提交</el-button
      >
    </div>
    <p class="stundent-name">
      学生姓名：<span>{{ $route.query.nickName }}</span>
    </p>
    <div class="main">
      <div class="box" v-for="(item, idx) in list" :key="idx">
        <p class="box_title">{{ item.title }}</p>
        <div class="content">
          <div class="one_row" v-for="(row, idx) in item.items" :key="idx">
            <!-- <span>{{ idx + 1 }}.</span> -->
            <span class="label">{{ row.name }}</span>
            <el-input-number
              v-model="scoreDetail[row.score]"
              :min="0"
              :max="4"
              size="small"
              controls-position="right"
            ></el-input-number>
          </div>
        </div>
      </div>
      <template v-if="scoreDetail.otherList.length > 0">
        <div
          class="box otherList"
          v-for="(item, i) in scoreDetail.otherList"
          :key="i + 9"
        >
          <p class="box_title">
            自定义考核点{{ i + 1 }}
            <i class="el-icon-circle-close" @click="handleDel(i)"></i>
          </p>
          <div class="content" style="text-align: left">
            <el-form :model="item" ref="form" size="small" label-width="50px">
              <el-form-item label="考核:" prop="label">
                <el-select
                  v-model="item.label"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择考核"
                >
                  <el-option
                    v-for="o in options"
                    :key="o"
                    :label="o"
                    :value="o"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="得分:" prop="score">
                <el-input-number
                  v-model="item.score"
                  :min="-10"
                  :max="10"
                  controls-position="right"
                ></el-input-number>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </template>
      <div
        class="box plus"
        @click="scoreDetail.otherList.push({ label: '', score: 0 })"
      >
        <el-button type="primary" icon="el-icon-circle-plus-outline"
          >新增素养考核点</el-button
        >
      </div>
      <!-- <div class="box btn-box">
        <el-button
          v-show="!info.syComplete"
          type="primary"
          icon="el-icon-coin"
          @click="handleSubmit"
          >提交评分</el-button
        >
      </div> -->
    </div>
  </div>
</template>

<script>
import { appraiseDetail, saveAppraise } from "@/api/chapter";

export default {
  props: {
    info: Object,
  },
  data() {
    return {
      list: [
        {
          title: "学业成绩",
          items: [
            {
              name: "学习态度",
              score: "cxys",
            },
            {
              name: "成绩稳定性",
              score: "hzdd",
            },
            {
              name: "学习进步",
              score: "fzxy",
            },
          ],
        },
        {
          title: "学习方法",
          items: [
            {
              name: "计划制定",
              score: "gjys",
            },
            {
              name: "学习时间安排",
              score: "zzrt",
            },
            {
              name: "学习资料整理",
              score: "whzx",
            },
          ],
        },
        {
          title: "学习能力",
          items: [
            {
              name: "思维能力",
              score: "qqsy",
            },
            {
              name: "推理能力",
              score: "zzcy",
            },
            {
              name: "创新能力",
              score: "stcs",
            },
          ],
        },
        {
          title: "学习态度",
          items: [
            {
              name: "学习主动性",
              score: "rwjd",
            },
            {
              name: "学习积极性",
              score: "rwqh",
            },
          ],
        },
        {
          title: "综合素质",
          items: [
            {
              name: "语言表达能力",
              score: "cszz",
            },
            {
              name: "社交能力",
              score: "lxsw",
            },
            {
              name: "实践能力",
              score: "yyyj",
            },
          ],
        },
        {
          title: "体育健康",
          items: [
            {
              name: "体育成绩",
              score: "gwjs",
            },
            {
              name: "体能测试",
              score: "cybd",
            },
          ],
        },
        {
          title: "社会实践",
          items: [
            {
              name: "社会实践经历",
              score: "lxsx",
            },
            {
              name: "社会责任感",
              score: "qyfs",
            },
            {
              name: "组织协调能力",
              score: "szxx",
            },
          ],
        },
        {
          title: "因对困难",
          items: [
            {
              name: "问题解决能力",
              score: "zasm",
            },
            {
              name: "适应能力",
              score: "jqrg",
            },
            {
              name: "坚持不懈",
              score: "sxfz",
            },
          ],
        },
        {
          title: "审美与表现",
          items: [
            {
              name: "感受美",
              score: "rald",
            },
            {
              name: "表达美",
              score: "ppzy",
            },
            {
              name: "创造美",
              score: "wtjj",
            },
          ],
        },
      ],
      scoreDetail: {
        classChapterId: null,
        userId: null,
        cxys: 3,
        hzdd: 3,
        fzxy: 3,
        stcs: 3,
        gjys: 3,
        zzrt: 3,
        whzx: 3,
        qqsy: 3,
        zzcy: 3,
        rwjd: 3,
        rwqh: 3,
        cszz: 3,
        lxsw: 3,
        yyyj: 3,
        gwjs: 3,
        cybd: 3,
        lxsx: 4,
        qyfs: 4,
        szxx: 3,
        zasm: 3,
        jqrg: 4,
        sxfz: 3,
        rald: 4,
        ppzy: 4,
        wtjj: 3,
        otherList: [],
      },
      options: [
        "上课期间手机未上交",
        "玩手机、玩电脑（打开与上课无关页面）",
        "嬉笑打闹、大声喧哗",
        "上课睡觉",
        "不交作业",
        "迟到或未按时签到",
        "老师讲课期间戴耳机",
        "自己随意调换座位",
        "上课期间组员不得去其他组",
        "上课带零食、吃零食、带杯装饮料等进实训室",
        "积极参与回答问题",
        "积极组织讨论",
        "优秀作业",
        "遵守纪律",
        "积极提问（问作业做什么的除外）",
        "小组全部交齐作业",
        "认真听课记笔记",
        "辅助老师完成工作",
      ],
    };
  },
  activated() {
    this.getDetail();
  },
  deactivated() {
    this.scoreDetail = this.$options.data().scoreDetail;
  },
  methods: {
    getDetail() {
      let classChapterId = this.$route.query.classChapterId;
      let userId = this.$route.query.userId;
      this.$loading.show();
      appraiseDetail({ classChapterId, userId }).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          if (res.data) this.scoreDetail = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleDel(idx) {
      this.$confirm("确定要删除该项吗?", {
        type: "warning",
      })
        .then(() => {
          this.scoreDetail.otherList.splice(idx, 1);
        })
        .catch(() => {});
    },
    handleSubmit() {
      this.scoreDetail.classChapterId = this.$route.query.classChapterId;
      this.scoreDetail.userId = this.$route.query.userId;
      this.$loading.show();
      delete this.scoreDetail.total;
      saveAppraise(this.scoreDetail).then((res) => {
        this.$loading.hide();
        if (res.code == 0) {
          this.$message.success("评分成功");
          this.getDetail();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.appraise-detail {
  padding: 20px 0;
  height: 100%;
  overflow: inherit;
  .title {
    position: relative;
    height: 52px;
    line-height: 52px;
    text-align: center;
    border-radius: 2px;
    // background-color: #fff;
    // box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);
    .back-btn {
      position: absolute;
      left: 20px;
      top: 50%;
      transform: translateY(-50%);
    }
    b {
      font-size: 30px;
    }
    .submit-btn {
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .stundent-name {
    margin-top: 10px;
    font-size: 16px;
    text-align: left;
    span {
      color: #1890ff;
    }
  }
  .main {
    margin: 10px -10px;
    text-align: left;
    height: calc(100% - 52px - 20px);
    overflow-y: auto;
    border-left: solid 1px #c8c8c8;
    border-top: solid 1px #c8c8c8;
    &::-webkit-scrollbar {
      width: 4px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #c8c8c8;
    }
    .box {
      display: inline-block;
      // margin: 10px;
      width: 300px;
      height: 250px;
      text-align: center;
      border-right: solid 1px #c8c8c8;
      border-bottom: solid 1px #c8c8c8;
      // box-shadow: 0 0 4px rgba(0, 0, 0, 0.15);
      vertical-align: top;
      &.plus {
        position: relative;
        line-height: 250px;
        background-color: #fff;
      }
      .box_title {
        padding: 0 10px;
        height: 50px;
        line-height: 50px;
        font-size: 16px;
        font-weight: 600;
        color: #409eff;
        background-color: #fff;
        .el-icon-circle-close {
          float: right;
          margin-top: 15px;
          font-size: 20px;
          color: #f56c6c;
          transition: all 0.3s ease;
          cursor: pointer;
        }
      }
      .content {
        padding: 20px;
        height: 199px;
        background-color: #fff;
        .one_row {
          //   padding: 6px 0;
          margin-bottom: 10px;
          font-size: 16px;
          .label {
            display: inline-block;
            margin-right: 10px;
            min-width: 100px;
            text-align: left;
          }
        }

        ::v-deep .memo-input {
          margin-top: 10px;
          .el-textarea__inner {
            font-family: inherit;
            color: inherit;
          }
        }
      }
      &.btn-box {
        box-shadow: inherit;
        line-height: 268px;
      }
    }
  }
}
</style>
